import { Code } from '@nextui-org/react';
import React, { useState } from 'react';
import AnomalyDrawer from './AnomalyDrawer';

/**
 * Anomaly Component
 * Displays anomaly detection results with interactive drawer
 * Shows detected anomaly type and allows users to view detailed information
 * @param {Object} props - Component props
 * @param {Object} props.threadResp - Thread response data containing anomaly information
 * @returns {JSX.Element} Anomaly detection display component
 */
const Anomaly = ({ threadResp }) => {
  // Component state
  const [isOpen, setIsOpen] = useState(false);
  
  return (
    <>
      {/* Anomaly Detail Drawer */}
      <AnomalyDrawer 
        isOpen={isOpen} 
        setIsOpen={setIsOpen} 
        threadResp={threadResp} 
      />
      
      {/* Anomaly Display */}
      <div className="gap-2 pl-12 pt-4 pb-2">
        This looks like a{" "}
        <span>
          <Code color="secondary" size="sm">
            {threadResp?.anomaly}
          </Code>
        </span>
        . Would you like it to your anomaly list?{" "}
        <span 
          onClick={() => setIsOpen(true)} 
          className="text-emerald-500 hover:underline cursor-pointer"
        >
          View Anomaly
        </span>
      </div>
    </>
  );
};

export default Anomaly;
